export const EDITOR_MODAL_UNSPLASH_TAB_IMAGES = 'Images';
export const EDITOR_MODAL_UNSPLASH_TAB_GIFS = 'Gifs';
export const EDITOR_MODAL_UNSPLASH_TAB_STICKERS = 'Stickers';
